import { useQuery, useQueryClient } from "react-query";
import config from "../../config";
import { apiVersion } from "../../shared/constants/common.constant";
import { createQueryString } from "../../utils";
import { getAsync } from "../protect-api";
import { PROFILE_REPORTS } from "../reports";
import { NotificationQueryParam, NotificationResponse } from "./types";

export const NOTIFICATIONS_KEY = "notifications";

const getNotifications = async (
  query: NotificationQueryParam
): Promise<NotificationResponse> => {
  try {
    const { data } = await getAsync(
      `${
        config.COMPLIANCE_API_URL
      }/${apiVersion}/notifications?${createQueryString(query)}`,
      undefined,
      undefined,
      true
    );
    return {
      items: data,
      apiFailed: false,
    };
  } catch (error) {
    return {
      items: [],
      apiFailed: true,
    };
  }
};

export const useGetNotifications = (
  query: NotificationQueryParam,
  onRefetch?: () => void
) => {
  const queryClient = useQueryClient();
  return useQuery<NotificationResponse>(
    [NOTIFICATIONS_KEY, query],
    () => getNotifications(query),
    {
      refetchInterval: 60000,
      refetchIntervalInBackground: true,
      onSuccess: () => {
        queryClient.invalidateQueries(PROFILE_REPORTS);
        if (onRefetch) {
          onRefetch();
        }
      },
    }
  );
};
